export const FETCH_PAYMENT_STOCK_LOCATIONS_PENDING =
  'FETCH_PAYMENT_STOCK_LOCATIONS_PENDING';
export const FETCH_PAYMENT_STOCK_LOCATIONS_REJECTED =
  'FETCH_PAYMENT_STOCK_LOCATIONS_REJECTED';
export const FETCH_PAYMENT_STOCK_LOCATIONS_FULFILLED =
  'FETCH_PAYMENT_STOCK_LOCATIONS_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/paymentStockLocations.js